import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import Swal from "sweetalert2";
import { MESSAGE_EVENT } from "../enums";
import { CHAT_COUNTER, CommonWebService, CREATE_GROUP, EDIT_MESSAGE, EmployeeDetail, GET_MESSAGE_LIST, GROUP_DETAIL, GROUP_LIST, GROUP_MEMBER, HttpChatCounterResponse, HttpGroupResponse, HttpResponse, MESSAGE_DETAIL, MESSAGE_GROUP_DETAIL, SEND_MESSAGE_BODY, UserHttpService } from "../public-api";

@Injectable({
    providedIn: "root"
})
export class MessengerService {
    public $chatEvent: Subject<MESSAGE_EVENT> = new Subject();
    public $activeUserId: BehaviorSubject<{ isGroup: boolean, id: string }> = new BehaviorSubject<{ isGroup: boolean, id: string }>({ isGroup: false, id: '' });
    public currentUserInfo$: BehaviorSubject<{ isGroup: boolean, data: any }> = new BehaviorSubject<{ isGroup: boolean, data: any }>({ isGroup: false, data: '' });
    public $getList: BehaviorSubject<any> = new BehaviorSubject(false);
    public $editMessage: Subject<EDIT_MESSAGE> = new Subject();
    public chatCounterData: BehaviorSubject<CHAT_COUNTER> = new BehaviorSubject({ data: 0, group_listData: [''], singleChat_sentby: [''] });

    private searchKeyword = new BehaviorSubject<string>(''); // Default empty search
    searchKeyword$ = this.searchKeyword.asObservable();

    constructor(
        private http: HttpClient,
        private userSessionService: UserHttpService
    ) { }


    public sendMessage(body: SEND_MESSAGE_BODY, event: MESSAGE_EVENT) {
        if (event == MESSAGE_EVENT.SEND_PRIVATE_MESSAGE) {
            let formData = new FormData();
            formData.append('sent_by', body.sent_by ? body.sent_by : "");
            formData.append('sent_to', body.sent_to ? body.sent_to : "");
            if (body.message) {
                formData.append('message', body.message ? body.message : '');
            }

            if (body.file) {
                formData.append('file', body.file ? body.file : '');
            };

            if (body.message_id) {
                formData.append('message_id', body.message_id);
            };

            this.http.post<HttpResponse<any>>('chat/chat', formData).subscribe({
                next: ((res) => {
                    if (res.status) {
                        this.$chatEvent.next(MESSAGE_EVENT.MESSAGE_SENT);
                    } else {
                        Swal.fire("Oops...", res.message, "error");
                    }
                }),
                error: ((err) => {
                    console.log(err);
                    Swal.fire("Oops...", err, "error");
                })
            });
        } else if (event == MESSAGE_EVENT.SEND_GROUP_MESSAGE) {
            let formData = new FormData();
            formData.append('sent_by', body.sent_by ? body.sent_by : "");
            formData.append('sent_to', body.send_toUsers && body.send_toUsers.length > 0 ? JSON.stringify(body.send_toUsers) : JSON.stringify([]));
            formData.append('group_id', body.group_id ? body.group_id : "");

            if (body.message) {
                formData.append('message', body.message ? body.message : '');
            }

            if (body.file) {
                formData.append('file', body.file ? body.file : '');
            };

            if (body.message_id) {
                formData.append('message_id', body.message_id);
            };

            this.http.post<HttpResponse<any>>('chat/groupchat', formData).subscribe({
                next: ((res) => {
                    if (res.status) {
                        this.$chatEvent.next(MESSAGE_EVENT.MESSAGE_SENT);
                    } else {
                        Swal.fire("Oops...", res.message, "error");
                    }
                }),
                error: ((err) => {
                    console.log(err);
                    Swal.fire("Oops...", err, "error");
                })
            });
        }
    }

    public chatList(body: GET_MESSAGE_LIST): Observable<HttpResponse<MESSAGE_DETAIL[]>> {
        let formData = new FormData();
        formData.append('sent_by', body.sent_by ? body.sent_by : "");
        formData.append('sent_to', body.sent_to ? body.sent_to : "");
        return this.http.post<HttpResponse<MESSAGE_DETAIL[]>>('chat/chat/list', formData);
    }

    public chatGroupMessages(groupid: string): Observable<HttpResponse<MESSAGE_GROUP_DETAIL[]>> {
        let formData = new FormData();
        formData.append('group_id', groupid ? groupid : "");
        formData.append('user_id', this.userSessionService.getUserInfo.user_id ? this.userSessionService.getUserInfo.user_id : "");
        return this.http.post<HttpResponse<MESSAGE_GROUP_DETAIL[]>>('chat/groupchat/list', formData);
    }

    public groupInfo(groupId: string): Observable<HttpResponse<GROUP_DETAIL[]>> {
        let formData = new FormData();
        formData.append("user_id", this.userSessionService.getUserInfo.user_id);
        formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append("token", this.userSessionService.userToken);
        formData.append("group_id", groupId ? groupId : "");
        return this.http.post<HttpResponse<GROUP_DETAIL[]>>('chat/groupInfo', formData);
    }

    public deleteGroup(groupId: string): Observable<HttpResponse<any>> {
        let formData = new FormData();
        formData.append("user_id", this.userSessionService.getUserInfo.user_id);
        formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
        formData.append("token", this.userSessionService.userToken);
        formData.append("group_id", groupId ? groupId : "");
        return this.http.post<HttpResponse<any>>('chat/createChatGroup/deletegroup', formData);
    }

    public createGroup(body: CREATE_GROUP, isEdit: boolean = false): Observable<HttpResponse<any>> {
        let formData = new FormData();
        formData.append("user_id", this.userSessionService.getUserInfo.user_id);
        formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
        formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append("token", this.userSessionService.userToken);
        formData.append("group_name", body.group_name ? body.group_name : "");
        formData.append("group_status", body.group_status ? body.group_status : "1");

        if (body.chatusers && body.chatusers.length > 0) {
            body.chatusers.forEach((X, i) => {
                formData.append(`chatusers[${i}]`, X ? X : "");
            })
        };

        if (body.group_id && isEdit) {
            formData.append("group_id", body.group_id ? body.group_id : "");
        }

        return this.http.post<HttpResponse<any>>('chat/createChatGroup', formData);
    }

    public editGroupName(name: string, id: string): Observable<HttpResponse<any>> {
        let formData = new FormData();
        formData.append("user_id", this.userSessionService.getUserInfo.user_id);
        formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
        formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append("token", this.userSessionService.userToken);
        formData.append("group_status", "1");
        formData.append("group_name", name ? name : "");
        formData.append("group_id", id ? id : "");

        return this.http.post<HttpResponse<any>>('chat/createChatGroup', formData);
    }

    public editGroupUsers(name: string, users: string[], id: string): Observable<HttpResponse<any>> {
        let formData = new FormData();
        formData.append("user_id", this.userSessionService.getUserInfo.user_id);
        formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
        formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append("token", this.userSessionService.userToken);
        formData.append("group_status", "1");
        formData.append("group_id", id ? id : "");
        formData.append("group_name", name ? name : "");

        if (users && users.length > 0) {
            users.forEach((X, i) => {
                formData.append(`chatusers[${i}]`, X ? X : "");
            })
        };

        return this.http.post<HttpResponse<any>>('chat/createChatGroup', formData);
    }


    public removeGroupMembers(userid: string, groupid: string): Observable<HttpResponse<any>> {
        let formData = new FormData();
        formData.append("user_id", this.userSessionService.getUserInfo.user_id);
        formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append("token", this.userSessionService.userToken);
        formData.append("remove_user_id", userid ? userid : "");
        formData.append("group_id", groupid ? groupid : "");

        return this.http.post<HttpResponse<any>>('chat/groupInfo/removeuser', formData);
    }

    public groupList(): Observable<HttpResponse<GROUP_LIST[]>> {
        let formData = new FormData();
        formData.append("user_id", this.userSessionService.getUserInfo.user_id);
        formData.append("usr_customer_track_id", this.userSessionService.getUserInfo.usr_customer_track_id);
        formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append("token", this.userSessionService.userToken);
        return this.http.post<HttpResponse<GROUP_LIST[]>>('chat/chatGroupList', formData);
    }

    public deleteSingleMessage(id: string, isGroup: boolean = false, groupId?: string): Observable<HttpResponse<any>> {
        let formData = new FormData();
        formData.append("message_id", id ? id : "");

        if (isGroup) {
            formData.append("group_id", groupId ? groupId : "");
            formData.append("user_id", this.userSessionService.getUserInfo.user_id ? this.userSessionService.getUserInfo.user_id : "");
        };
        let url = isGroup ? 'chat/groupchat/deletemessage' : 'chat/chat/deletemessage';
        return this.http.post<HttpResponse<any>>(url, formData);
    }

    public clearChat(body: GET_MESSAGE_LIST): Observable<HttpResponse<any>> {
        let formData = new FormData();
        if (body.isGroup) {
            formData.append("group_id", body.sent_to ? body.sent_to : "");
            formData.append("user_id", this.userSessionService.getUserInfo.user_id ? this.userSessionService.getUserInfo.user_id : "");
            return this.http.post<HttpResponse<any>>('chat/groupchat/clearChat', formData);
        } else {
            formData.append("user_id", this.userSessionService.getUserInfo.user_id ? this.userSessionService.getUserInfo.user_id : "");
            formData.append("sent_by", body.sent_by ? body.sent_by : "");
            formData.append("sent_to", body.sent_to ? body.sent_to : "");
            return this.http.post<HttpResponse<any>>('chat/chat/clearChat', formData);
        }
    }

    public chatCounter(): Observable<HttpChatCounterResponse> {
        let formData = new FormData();
        formData.append("user_id", this.userSessionService.getUserInfo.user_id);
        formData.append("usr_role_track_id", this.userSessionService.getUserInfo.usr_role_track_id);
        formData.append("token", this.userSessionService.userToken);
        return this.http.post<HttpChatCounterResponse>('chat/ChatMessageCounter', formData);
    }

    public markMessagesAsRead(id: string, isGroup: boolean = false): Observable<HttpResponse<any>> {
        let formData = new FormData();
        formData.append("user_id", this.userSessionService.getUserInfo.user_id);
        formData.append("token", this.userSessionService.userToken);
        if (isGroup) {
            formData.append("group_id", id ? id : '');
        } else {
            formData.append("sent_by", id ? id : '');
        }
        return this.http.post<HttpResponse<any>>('chat/readMessage/', formData);
    }

    public setSearchKeyword(keyword: string) {
        this.searchKeyword.next(keyword);
    }

    // "Amit, Neha, Raj +4" - names beyond the limit are collapsed into a count
    public groupMembersLabel(members: GROUP_MEMBER[] | undefined, limit: number = 3): string {
        const names = (members ? members : [])
            .map((member) => `${member.user_firstname ? member.user_firstname : ''} ${member.user_lastname ? member.user_lastname : ''}`.trim())
            .filter((name) => name !== '');

        if (names.length === 0) {
            return '';
        }

        const visible = names.slice(0, limit).join(', ');
        return names.length > limit ? `${visible} +${names.length - limit}` : visible;
    }

    // "26 Sep, 2026 - 12:34 PM" - the API formats the date itself, so whatever mask
    // the server is running is normalised here before it reaches the chat bubble.
    public chatTimestamp(value: string | Date | undefined): string {
        if (!value) {
            return '';
        }

        const parsed = value instanceof Date ? value : new Date(`${value}`.replace(' - ', ' '));

        if (isNaN(parsed.getTime())) {
            return `${value}`;
        }

        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
        const day = `0${parsed.getDate()}`.slice(-2);
        const minutes = `0${parsed.getMinutes()}`.slice(-2);
        const hours = parsed.getHours() % 12 === 0 ? 12 : parsed.getHours() % 12;
        const meridiem = parsed.getHours() < 12 ? 'AM' : 'PM';

        return `${day} ${months[parsed.getMonth()]}, ${parsed.getFullYear()} - ${hours}:${minutes} ${meridiem}`;
    }
}